module.exports = __webpack_public_path__ + "img/discord_request.61df25ef.jpg";